import React from "react";
import MainFaqs from "../Components/Faqs";

const Faqs = () => <MainFaqs />;

export default Faqs;
